












import { createPopper } from '@popperjs/core';

export default {
  name: 'explain-result-tooltip',
  props: {
    result: {
      type: Object,
      required: true
    }
  },
  computed: {
    imageUrl: function (): string {
      return (this.result.imageUrl || this.defaultImageUrl);
    }
  },
  data: function () {
    return {
      defaultImageUrl: require('../../assets/media/image/image-not-found.svg'),
      popper: undefined
    };
  },
  methods: {
    onImageError: function (event): void {
      event.target.src = this.defaultImageUrl;
    }
  },
  mounted: function (): void {
    if (!!this.$refs.caption) {
      this.popper = createPopper(this.$el, this.$refs.caption, {
        placement: 'right',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 3]
            }
          }
        ]
      });
    }
  },
  destroyed: function (): void {
    if (!!this.popper) {
      this.popper.destroy();
    }
  }
};
